import axios from 'axios';
import { WorkerSchedule } from '../types';

const API_URL = process.env.REACT_APP_API_URL || 'https://makicheck.com/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const workerScheduleService = {
  async getWorkerSchedules(workerId: number): Promise<WorkerSchedule[]> {
    const response = await api.get(`/worker-schedules/${workerId}`);
    return response.data;
  },

  async getMySchedules(): Promise<WorkerSchedule[]> {
    const response = await api.get('/worker-schedules/me/mine');
    return response.data;
  },

  async saveWorkerSchedule(workerId: number, scheduleData: {
    day_of_week: string;
    entry_time: string;
    exit_time: string;
  }): Promise<WorkerSchedule> {
    const response = await api.post(`/worker-schedules/${workerId}`, scheduleData);
    return response.data;
  },

  async deleteWorkerSchedule(workerId: number, dayOfWeek: string): Promise<void> {
    await api.delete(`/worker-schedules/${workerId}/${dayOfWeek}`);
  },
};
